import { useCallback, useRef, useState } from 'react';

import { EditOption } from '../types';

export const useEditOptions = (
  getEditOptions?: () => Promise<Array<EditOption>>
): { options: Array<EditOption>; isLoading: boolean; hasError: boolean; load(): void } => {
  const [options, setOptions] = useState<Array<EditOption>>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const hasLoadedRef = useRef(false);

  const load = useCallback(() => {
    if (hasLoadedRef.current || !getEditOptions) {
      return;
    }
    hasLoadedRef.current = true;
    setIsLoading(true);
    setHasError(false);
    getEditOptions()
      .then((result) => setOptions(result))
      .catch(() => {
        setOptions([]);
        setHasError(true);
        hasLoadedRef.current = false;
      })
      .finally(() => setIsLoading(false));
  }, [getEditOptions]);

  return { options, isLoading, hasError, load };
};
